import clsx from 'clsx';
import { Icon as LucideIcon } from 'lucide-react';
import { Icon } from '../Icon/Icon';
import { jsx as _jsx } from "react/jsx-runtime";
const iconNode = [['path', {
  d: 'M1.5 6h21',
  key: 'qvr8o0'
}], ['path', {
  d: 'M13.2 12.324h6',
  key: 'ievbxr'
}], ['path', {
  d: 'M13.2 15.731h6',
  key: '1xi7w4'
}], ['path', {
  d: 'M4.125 1.5C2.675 1.5 1.5 2.754 1.5 4.3v15.4c0 1.546 1.175 2.8 2.625 2.8h15.75c1.45 0 2.625-1.254 2.625-2.8V4.3c0-1.546-1.175-2.8-2.625-2.8z',
  key: '63pkfq'
}], ['rect', {
  x: '4.86',
  y: '9.735',
  width: '5.25',
  height: '9',
  rx: '1',
  key: 'd3ghgn'
}]];
export function ProductWebhosting({
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Icon, {
    icon: LucideIcon,
    iconNode: iconNode,
    className: clsx('lucide-custom-product-webhosting', className),
    ...extraProps
  });
}